import { render, staticRenderFns } from "./TaskSearch.vue?vue&type=template&id=738d8922&"
import script from "./TaskSearch.vue?vue&type=script&lang=ts&"
export * from "./TaskSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports